import Cookies from "js-cookie";

let TOKEN = "Admin-Token";
let DETAIL = "userDetail";
import { getCookieDomain } from "@/utils/config";
export function getToken() {
  return Cookies.get(TOKEN) || sessionStorage.getItem(TOKEN);
}

export function setUserInfo(detail){
  Cookies.remove(DETAIL)
  sessionStorage.removeItem(DETAIL)
  Cookies.set(DETAIL, detail)
  sessionStorage.setItem(DETAIL, detail)
}

export function getUserInfo(){
  if(Cookies.get(DETAIL)){
    return Cookies.get(DETAIL)
  }else{
    return sessionStorage.getItem(DETAIL)
  }
}

export function removeUserInfo(){
  console.log("remove user info");
  
  Cookies.remove(DETAIL)
  sessionStorage.removeItem(DETAIL)
}

export function setToken(token, flag) {
  Cookies.remove(TOKEN);
  sessionStorage.removeItem(TOKEN);
  if (flag) {
    if (getCookieDomain() === "localhost") {
      Cookies.set(TOKEN, token);
    } else {
      Cookies.set(TOKEN, token, {
        expires: 7,
        domain: getCookieDomain()
      });
    }
  } else {
    sessionStorage.setItem(TOKEN, token);
  }
}

export function removeToken() {
  Cookies.remove(TOKEN, { domain: getCookieDomain() });
  sessionStorage.removeItem(TOKEN);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js